import React from 'react';

interface JsonViewProps {
  data: any;
  indent?: number;
}

const JsonView: React.FC<JsonViewProps> = ({ data, indent = 2 }) => {
  const formattedJson = JSON.stringify(data, null, indent);

  return (
    <pre className="bg-gray-50 p-4 rounded-lg overflow-auto text-sm font-mono m-0 max-h-96 border border-gray-200">
      {formattedJson}
    </pre>
  );
};

export default JsonView;
